import { LoadableAfterPaint } from '@confluence/loadable';

export const GlobalPermissionsUserRow = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-componentsGroupAndUserItemGroupAndUserItem" */ '../src/components/GroupAndUserItem/GroupAndUserItem.tsx'
			)
		).UserRow,
});
